import styled from "styled-components";

import Button from "~/components/ui/Button";

import { responsive, getColor, getColorWithAlpha } from "~/helpers/style";

import successBackground01 from "~/assets/svg/onboarding-flow-success-01.svg";
import successBackground02 from "~/assets/svg/onboarding-flow-success-02.svg";
import shopifyLogo from "~/assets/svg/shopifyImg.svg";
import storePreview from "~/assets/svg/onboarding-flow-success-preview.png";
import rightArrowIcon from "~/assets/svg/onboarding-flow-right-white-arrow.svg";

export const Container = styled.div`
  padding-top: 50px;

  ${responsive("mobileL")} {
    width: 100%;
  }

  ${responsive("laptopL")} {
    width: 790px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 38px;
    position: relative;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
`;

export const IntroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 0px 10px;
  border-radius: 43px;
  background-color: ${getColorWithAlpha("primary", 0.1)};
`;

export const IntroText = styled.p`
  text-align: center;
  font-family: "Inter Variable";
  font-style: normal;
  padding-block: 8px;
  font-weight: 600;
  margin-block: 0;
  color: ${() => getColor("primary")};
  line-height: normal;
  font-size: 14px;

  ${responsive("mobileL")} {
    font-size: 14px;
  }
`;

export const MainText = styled.p`
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  color: ${() => getColor("text")};
  margin-bottom: 6px;
  margin-block: 0;
  text-align: center;
  margin-top: 12px;
  align-items: center;
  line-height: 158%;

  ${responsive("mobileL")} {
    margin-bottom: 0px;
    min-width: 80%;
  }
`;

export const ShopifyLogo = styled.img.attrs({
  src: shopifyLogo,
  alt: "Shopify logo",
})`
  width: 90px;
  margin-inline: 0;
  vertical-align: middle;
  ${responsive("mobileL")} {
    margin-inline: 2px;
  }
`;

export const SubText = styled.p`
  font-family: "Inter Variable";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: ${() => getColor("text")};
  margin-bottom: 0px;
  max-width: 90%;
  text-align: center;
  margin-block: 12px;

  ${responsive("mobileL")} {
    max-width: 80%;
  }
`;

export const StyledButton = styled(Button)`
  display: flex;
  background-color: ${getColor("primary")};
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: "Inter Variable";
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 182%;
  border-radius: 8px;
  color: ${() => getColor("white")};
  margin-bottom: 0;
  width: 70%;
  padding: 11px 58px;
  margin-inline: auto;

  ${responsive("mobileL")} {
    width: auto;
    padding: 8px 24px;
  }
`;

export const ArrowIcon = styled.img.attrs({
  src: rightArrowIcon,
  alt: "Arrow icon",
})`
  width: 20px;
`;

export const SuccessBackground01 = styled.img.attrs({
  src: successBackground01,
  alt: "Success bg 01",
})`
  width: 100%;
  position: absolute;
  top: 70px;
`;

export const SuccessBackground02 = styled.img.attrs({
  src: successBackground02,
  alt: "Success bg 02",
})`
  width: 100%;
  position: absolute;
  top: -20px;
`;

export const StorePreviewImage = styled.img.attrs({
  src: storePreview,
  alt: "Store Preview",
})`
  width: 100%;
  box-shadow: 0px 6px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin-top: 30px;
  background: #fff;
  transform: translateY(24px);

  ${responsive("mobileL")} {
    width: 80%;
    transform: translateY(40px);
    margin-inline: auto;
    object-fit: cover;
  }
`;
